import 'swiper/css';
import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import './solution-overview.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// Cards are a horizontal carousel with a scrollbar pill on mobile/tablet
// (Figma 297-2783); from desktop up all four cards fit, so the scrollbar is
// hidden. Breakpoints match the SCSS ones (tablet 768, tablet-xlg 1025,
// desktop 1441).
function initCarousel( el: HTMLElement ): void {
	if ( ! once( el, 'SolutionCarousel' ) ) {
		return;
	}
	const scrollbar = el.parentElement?.querySelector<HTMLElement>( '.solution-overview__scrollbar' );

	new Swiper( el, {
		modules: [ Scrollbar ],
		slidesPerView: 1.15,
		spaceBetween: 30,
		scrollbar: scrollbar ? { el: scrollbar, draggable: true } : false,
		breakpoints: {
			768: {
				slidesPerView: 2.2,
			},
			1025: {
				slidesPerView: 3.2,
			},
			1441: {
				slidesPerView: 4,
			},
		},
	} );
}

onBlockRender( 'solution-overview', ( root ) => {
	findAll<HTMLElement>( root, '[data-solution-carousel]' ).forEach( initCarousel );
} );
